import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { v4 as uuidv4 } from 'uuid';

const TableSkeletonLoader = ({
  numRows = 10, numColumns = 10, skeletonHeight = 20, skeletonTHeadWidth = '80%', skeletonWidth = '100%', skeletonBorderRadius = '4px', shouldEnableAnimation = false,
}) => {
  return (
    <table className="w-full">
      <thead>
        <tr className="w-full text-md font-semibold tracking-wide h-min-13 text-left text-vamos-black bg-vamos-v-light-gray uppercase">
          {Array.from({ length: numColumns }).map(() => (
            <th key={`thead-${uuidv4()}`} className="px-4 py-3">
              <Skeleton
                width={skeletonTHeadWidth}
                height={skeletonHeight}
                borderRadius={skeletonBorderRadius}
                enableAnimation={shouldEnableAnimation}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: numRows }).map(() => (
          <tr key={`row-${uuidv4()}`} className="min-h-10 even:bg-vamos-v-light-gray">
            {Array.from({ length: numColumns }).map(() => (
              <td key={`cell-${uuidv4()}`} className="px-4 py-3">
                <Skeleton
                  width={skeletonWidth}
                  height={skeletonHeight}
                  borderRadius={skeletonBorderRadius}
                  enableAnimation={shouldEnableAnimation}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TableSkeletonLoader.propTypes = {
  shouldEnableAnimation: PropTypes.bool,
  numRows: PropTypes.number,
  numColumns: PropTypes.number,
  skeletonHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonTHeadWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonBorderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableSkeletonLoader;
